import * as React from "react";
// import getHtmlDataSet from "Utils/GetHtmlDataSet";
// import postData from "Utils/PostData";
import { useDispatch, useSelector } from "react-redux";
// import { MdOutlineBugReport } from "react-icons/md";
// import { bindActionCreators } from "redux";

// import './navbar.css';
// Assets

// import "../Assets/Navbar.sass";
import { useLocation } from "react-router-dom";
import ProfileButton from "./ProfileButton";
import LoginButton from "./LoginButton";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { modeRoutes, updateUserIsInstructor } from "Store/UserInfo/Actions";
// import fontawesome from '@fortawesome/fontawesome';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faQuestionCircle, faBell, faQuestion, faBookOpen } from '@fortawesome/free-solid-svg-icons'
// import logo from "./bodhitree.png";
// import process from "process";
import bodhitree_icon from "../Assets/bodhitree_icon.png";
import { getUserPriviliges } from "Store/UserInfo/Actions";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
// fontawesome.library.add(faQuestionCircle, faQuestion, faBookOpen, faBell);

const NavBar = (props) => {
  const { noLoginButton } = props;
  const isAuthenticated = useSelector((state) => state.userInfo.token !== null);
  const setMode = useSelector((state) => state.userInfo.mode);
  const token = useSelector((state) => state.userInfo.token);
  const userName = useSelector((state) => state.userInfo.userName);
  // const email = useSelector((state) => state.userInfo.email);
  const isInstructor = useSelector((state) => state.userInfo?.is_instructor);

  const dispatch = useDispatch();
  const location = useLocation();
  const params = location.pathname.split("/").filter((item) => item !== "");
  const param1 = params.length > 0 ? params[0] : "";
  const param2 = params.length > 1 ? params[1] : "";

//  // Function to send user info to backend when requested
//  const sendUserInfoToBackend = async () => {
//   try {
//     const response = await fetch('/logging_system/api/send_user_info/', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         // 'X-CSRFToken': getCookie('csrftoken'),
//       },
//       body: JSON.stringify({ username: userName }),
//     });
//     const data = await response.json();
//     log.log(data);
//   } catch (error) {
//     log.error('Error sending user info to backend:', error);
//   }
// };


// React.useEffect(() => {
//   // Attach the sendUserInfoToBackend function to the window object
//   window.sendUserInfoToBackend = sendUserInfoToBackend;
// }, [userName]); // Add userName as a dependency to useEffect

  React.useEffect(() => {
    async function getPrivileges() {
      let is_instructor = await getUserPriviliges();
      dispatch(updateUserIsInstructor(is_instructor?.is_instructor));
    }

    if (isAuthenticated) {
      if (isInstructor === undefined || isInstructor === null) {
        getPrivileges();
      }
    }
  }, [dispatch]);

  const handleModeChange = async (mode, token) => {
    //log.log("mode is new ", mode);
    let error = "Can't switch mode";
    if (setMode !== mode) {
      if (mode === "I") {
        let is_instructor = null;
        if (isInstructor === undefined || isInstructor === null) {
          is_instructor = await getUserPriviliges();
          dispatch(updateUserIsInstructor(is_instructor?.is_instructor));
        } else {
          is_instructor = isInstructor;
        }
        // log.log(is_instructor);
        if (is_instructor.is_instructor === true || is_instructor === true) {
          dispatch(modeRoutes(mode, token));
        } else {
          displayGlobalMessage("You are not an instructor!", "error");
        }
      } else {
        dispatch(modeRoutes(mode, token));
      }
    }
  };

  // const getProfileButton = () => {
  //   if (this.props.isAuthenticated) {
  //     return <ProfileButton title={this.props.userName} />;
  //   } else {
  //     return <LoginButton />;
  //   }
  // };

  return (
    <Navbar
      collapseOnSelect
      className="p-0"
      expand="lg"
      variant="light"
      style={{ borderBottom: "1px solid #E8EBEF", backgroundColor: "#FFF" }}
    >
      <Container fluid className="px-5">
        <Navbar.Brand className="text-secondary" href="/">
          <img
            // src="https://static.thenounproject.com/png/2048830-200.png"
            className="d-inline-block align-top"
            src={bodhitree_icon}
            alt="Bodhitree Logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
            {/* {isAuthenticated && (
              <>
                <Nav.Link
                  className="text-secondary font-weight-normal justify-content-sm-center justify-content-md-start"
                  style={{ fontSize: 21 }}
                  href="/courseware/courseslist"
                >
                  Dashboard
                </Nav.Link>
                <Nav.Link
                  className="text-secondary font-weight-normal justify-content-sm-center justify-content-md-start"
                  style={{ fontSize: 21 }}
                  href="/courseware"
                >
                  Explore
                </Nav.Link>
                <Nav.Link
                  className="text-secondary font-weight-normal justify-content-sm-center justify-content-md-start"
                  style={{ fontSize: 21 }}
                  href="/overviewdashboard"
                >
                  Overview
                </Nav.Link>
                <Nav.Link
                  className="text-secondary font-weight-normal justify-content-sm-center justify-content-md-start"
                  style={{ fontSize: 21 }}
                  href="/performance-dashboard"
                >
                  Performance View
                </Nav.Link>
              </>
            )} */}
          </Nav>
          <Nav>
            <Nav>
              <Nav.Link href="https://bit.ly/bodhi-manual">
                {/* <FontAwesomeIcon icon="question-circle" style={{ fontSize: "1.8em" }} className={'d-none d-md-inline-block'} /> */}
                <span className="d-md-none" style={{ fontSize: 21 }}>
                  {" "}
                  Help{" "}
                </span>
              </Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link href="#">
                {/* <FontAwesomeIcon icon="bell" style={{ fontSize: "1.8em" }} className={'d-none d-md-inline-block'} /> */}
                <span className="d-md-none" style={{ fontSize: 21 }}>
                  {" "}
                  Notifications{" "}
                </span>
              </Nav.Link>
            </Nav>
            {isAuthenticated && isInstructor && (
              <NavDropdown
                className="size16"
                title={
                  <>
                    <span className="mx-1 size16">
                      {setMode === "S" ? "Mode: Student" : "Mode: Instructor"}
                    </span>
                  </>
                }
                // id="collasible-nav-dropdown"
              >
                <NavDropdown.Item
                  // href="#action/3.1"
                  onClick={() => handleModeChange("S", token)}
                >
                  Student
                </NavDropdown.Item>
                <NavDropdown.Item
                  // href="#action/3.2"
                  onClick={() => handleModeChange("I", token)}
                >
                  Instructor
                </NavDropdown.Item>
              </NavDropdown>
            )}
            {isAuthenticated && (
              <Nav.Link
                className="d-flex justify-content-start align-items-center size16 weight400"
                style={{ color: "#0E0E1D" }}
                href="/courseware/courseslist"
              >
                <div
                  className={`${
                    param1 === "courseware" && param2 === "courseslist"
                      ? "navbar-selected-component"
                      : ""
                  }`}
                >
                  My Courses
                  {/* My Dashboard */}
                </div>
              </Nav.Link>
            )}
            <Nav.Link
              className="d-flex justify-content-start align-items-center size16 weight400"
              style={{ color: "#0E0E1D" }}
              href="/courseware"
            >
              <div
                className={`${
                  param1 === "courseware" && param2 === ""
                    ? "navbar-selected-component"
                    : ""
                }`}
              >
                Explore
              </div>
            </Nav.Link>
            {isAuthenticated ? (
              <ProfileButton
                title={userName}
                isAuthenticated={isAuthenticated}
                mode={setMode}
              />
            ) : !noLoginButton ? (
              <LoginButton />
            ) : (
              <></>
            )}
            {
              <Nav.Item className="d-flex align-items-center justify-content-center">
                <a
                  role="button"
                  className="btn btn-secondary"
                  href="https://forms.gle/rNU798gpQ5gswyhY8"
                  target="_blank"
                >
                  Feedback
                </a>
              </Nav.Item>
            }
            {/* {this.getProfileButton()} */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
